import { MultiplyIcon } from '@koaly/koaly-ui-icons';
import { spaceProp } from '@koaly/mixins';
import { createElement } from 'react';
import styled from 'styled-components';
import { Button } from '../Button/Button.js';
import { StyledHeading, Heading } from '../Heading/Heading.js';
import { useCloseDrawer } from './hooks/useCloseDrawer.js';

const Header = styled.header `
  ${({ spaceAfter }) => spaceProp(spaceAfter)};
  text-align: right;

  ${StyledHeading} {
    text-align: left;
  }
`;
const DrawerHeader = ({ closeButtonLabel, spaceAfter, title, variant }) => {
    const closeDrawer = useCloseDrawer();
    return (createElement(Header, { spaceAfter: spaceAfter },
        createElement(Button, { type: "button", onClick: closeDrawer, suffix: MultiplyIcon, appearance: "cta", variant: "basic", size: "small", iconOnly: true, spaceAfter: 16 }, closeButtonLabel),
        title && createElement(Heading, { variant: variant, size: "h1", as: "h2" }, title)));
};
DrawerHeader.defaultProps = {
    closeButtonLabel: 'Sluiten',
};

export { DrawerHeader };
//# sourceMappingURL=DrawerHeader.js.map
